export default __webpack_public_path__ + "static/media/course-3.e9b6290b.jpg";